export const APP_NAME = 'LYS';
export const USER_MODULE = 'user';
export const MESSENGER_MODULE = 'messenger';
export const META_MODULE = 'meta';
export const YCM_MODULE = 'ycm';
